
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-check",
      function () {
        return require("private-next-pages/credit-check.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-check"])
      });
    }
  